// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper_1sawe","autoSize":"autoSize__sNdZ","verticalCenterAlign":"verticalCenterAlign_2QInS","text":"text_1OLkD","allCaps":"allCaps_1bt3x","verticalBottomAlign":"verticalBottomAlign_1jaQy","empty":"empty_125I7","icon":"icon_33hiZ","disableEditing":"disableEditing_1SmYj","sizeCheck":"sizeCheck_xCSQF","wordLengthCheck":"wordLengthCheck_3h8Ai","flash":"flash_1Xrm0"};


//////////////////
// WEBPACK FOOTER
// ./app/components/moment-text/styles.scss
// module id = 473
// module chunks = 1